import axios from "axios";
import { GURL } from "./global";

export const GetMessages = (groupId: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(`${GURL}/messaging/v1/Messages?groupId=${groupId}`);
};
export const GetMessagesById = (id: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(`${GURL}/messaging/v1/Messages/GetMessagesById?id=${id}`);
};
export const SendMessage = (f: any) => {
  const formData = new FormData();
  //console.log("f.message", f.message);

  formData.append("message", f.message);
  formData.append("groupId", f.groupId);
  formData.append("messageTypes", f.messageTypes);
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .post(`${GURL}/Messaging/v1/Messages`, formData, config)
    .then((response) => {
      //GetFilesAsync(GetNoticeId);
      //console.log("response", response);
    })
    .catch((error) => {
      // Handle errors
    });
};
